var map = {
	"./acropolis.png": 1612,
	"./bana_hills.png": 2397,
	"./beach.png": 7031,
	"./clothes.png": 7022,
	"./colosseum.png": 2572,
	"./dash.png": 1136,
	"./default_image_1.png": 9003,
	"./default_image_2.png": 672,
	"./dubrovnik.png": 6746,
	"./eating.png": 542,
	"./eiffel.png": 3985,
	"./habour.png": 3589,
	"./hero1.png": 9415,
	"./hero2.png": 940,
	"./hero3.png": 7477,
	"./hot_air_balloon.png": 230,
	"./map1.png": 2079,
	"./map2.png": 5220,
	"./map3.png": 9117,
	"./map4.png": 4258,
	"./mountain.png": 1097,
	"./niagara.png": 1177,
	"./night.png": 12,
	"./profile.png": 7653,
	"./travel.png": 4340,
	"./ui/original-c0a3d9c59754288c3a396c68a1c98c02.png": 3899,
	"./ui/original-c8e7bb5b6acc7b2249f6a6a8c1600800.png": 882,
	"./ui/original-d801bd076c1302009c30146ef9aaa361.png": 5709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;